/**
 * src/three/audioFiles.js
 * ไฟล์เสียงถูกแพ็กเข้า assets ตอน build
 */
import bgmRage from '../assets/audio/bgm-rage.mp3?url';
import sfxShoot from '../assets/audio/sfx-shoot.mp3?url';
import sfxBreak from '../assets/audio/sfx-break.mp3?url';
import sfxFaceHit from '../assets/audio/sfx-face-hit.mp3?url';

export const AUDIO = {
  bgm: bgmRage,
  shoot: sfxShoot,
  break: sfxBreak,
  face: sfxFaceHit,
};

function looksLikeHtml(data) {
  const n = Math.min(24, data.byteLength);
  const bytes = new Uint8Array(data, 0, n);
  let text = '';
  for (let i = 0; i < bytes.length; i += 1) text += String.fromCharCode(bytes[i]);
  const s = text.trimStart().toLowerCase();
  return s.startsWith('<!') || s.startsWith('<html') || s.startsWith('<!doctype');
}

export async function fetchAudioBuffer(url) {
  const res = await fetch(url, { cache: 'force-cache' });
  if (!res.ok) throw new Error(`audio fetch ${res.status}`);
  const data = await res.arrayBuffer();
  if (!data?.byteLength || looksLikeHtml(data)) throw new Error('audio got html');
  return data;
}
